import React from "react";
import classnames from "classnames";

interface ButtonProps {
	children: React.ReactNode;
	onClick: () => void;
	type?: "primary" | "secondary";
	subType?: "default" | "outline";
	isLoading?: boolean;
	isDisabled?: boolean;
	className?: string;
}

const Button: React.FC<ButtonProps> = ({
	children,
	onClick,
	type = "primary",
	subType = "default",
	isLoading = false,
	isDisabled = false,
	className,
}) => {
	return (
		<button
			type="button"
			onClick={onClick}
			className={classnames(
				"px-8 py-3 w-full rounded-[5px] inline-flex justify-center items-center gap-2 text-sm font-semibold transition-all duration-200 ease-in-out",
				{
					"bg-king-red/90 hover:bg-king-red text-white":
						type === "primary" && subType === "default",
					"bg-white hover:bg-slate-50 text-king-red border border-king-red":
						type === "primary" && subType === "outline",
					"bg-pge-blue/90 hover:bg-pge-blue text-white border border-pge-blue":
						type === "secondary" && subType === "default",
					"bg-white hover:bg-pge-blue/5 text-pge-blue border border-pge-blue":
						type === "secondary" && subType === "outline",
					"opacity-50": isDisabled,
				},
				className,
			)}
		>
			{children}
		</button>
	);
};

export default Button;
